import AppRoutes from "./routes/AppRoutes";
import Navbar from "./components/common/Navbar";
import Footer from "./components/common/Footer";
import LiveDonationPopup from "./components/LiveDonationPopup";
import { useLocation } from "react-router-dom";

function App() {
  const location = useLocation();

  const hideLayout =
    location.pathname.startsWith("/admin/dashboard") ||
    location.pathname.startsWith("/volunteer/dashboard") ||
    location.pathname.startsWith("/admin/login");

  return (
    <>
      {!hideLayout && <Navbar />}
      <AppRoutes />
      {!hideLayout && <Footer />}
      {!hideLayout && <LiveDonationPopup />}
    </>
  );
}

export default App;
